module.exports = __webpack_public_path__ + "media/assets/fonts/Calibri-Light-bfc9611cc594de9eda6bc6d73c82eeda.ttf";